










import Vue from "vue";
import { EventSummary } from "../types";

// import humanizeDuration from "humanize-duration";
import ProcessGroup from "@/components/ProcessGroup.vue";
import { AxiosResponse } from "axios";
import { mapState } from "vuex";

export default Vue.extend({
  name: "Events",
  components: {
    ProcessGroup,
  },
  data() {
    return {
      processes: [] as Array<EventSummary>,
    };
  },
  computed: mapState(["timeRangeQuery"]),
  watch: {
    timeRangeQuery() {
      this.loadData();
    },
  },
  created() {
    this.loadData();
  },
  methods: {
    loadData() {
      this.$store.state.api_client
        .get("/live/event_summary", {
          params: this.$store.state.timeRangeQuery,
        })
        .then((response: AxiosResponse) => {
          this.processes = response.data.processes;
        })
        .catch((error: Error) => {
          console.log(error);
        });
    },
  },
});
